/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from 'react';
import { strings } from '../../intl/Strings';
import { FeedbackService, FeedbackType } from '../../services/FeedbackService';
import OCVFeedbackService from '../../services/OCVFeedbackService';
import { Action, ActionCard } from '../ActionsCard/ActionCard';
import FeedbackUI from '../feedback-ui/FeedbackUI';
import { useStyles } from './ActionsCardWithFeedback.styles';

type ActionCardWithFeedbackProps = {
    titleLines?: string[];
    actions?: Action[];
    feedbackService?: FeedbackService;
    onFeedbackStarted?: (type: FeedbackType) => void;
};

export const ActionCardWithFeedback: React.FC<ActionCardWithFeedbackProps> = ({
    actions,
    titleLines,
    feedbackService,
    onFeedbackStarted = () => { }
}) => {
    const styles = useStyles();

    // Use provided feedback service or create default
    const defaultFeedbackService = React.useMemo(
        () => feedbackService || new OCVFeedbackService(onFeedbackStarted),
        [feedbackService, onFeedbackStarted]
    );

    const feedbackFooter = (
        <div className={styles.footer}>
            <div>{strings.getString('feedback')}</div>
            <div className={styles.feedbackRow}>
                <FeedbackUI
                    isDisabled={false}
                    feedbackService={defaultFeedbackService}
                    useThumbIcons={true}
                    useMinimalPadding={true}
                    componentName="LftSidePaneCard"
                />
            </div>
        </div>
    );

    return (
        <ActionCard
            actions={actions}
            titleLines={titleLines}
            footer={feedbackFooter}
        />
    );
};
